import { NextSeo } from "next-seo";
import { Breadcrumbs } from "~/components/Breadcrumbs";
import { Navbar } from "~/components/Navbar";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { BreadcrumbSEO } from "~/modules/app/seo/BreadcrumbSEO";
import { getAllPosts } from "~/modules/blog/api/sanity";
import { BlogListPage } from "~/modules/blog/pages/list";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";

// // // //

export async function getStaticProps() {
    const posts = await getAllPosts();
    return {
        props: {
            posts,
        },
    };
}

const SEO_DESCRIPTION = "In-depth analysis on real-world assets";

export default function BlogPage(props: any) {
    return (
        <PageTrack route={Routes.blog}>
            <NextSeo
                title="Blog"
                canonical={addBaseUrl(Routes.blog)}
                description={SEO_DESCRIPTION}
                openGraph={{
                    type: "website",
                    url: addBaseUrl(Routes.blog),
                    title: "RWA.xyz - Blog",
                    site_name: "RWA.xyz",
                    description: SEO_DESCRIPTION,
                }}
            />
            <BreadcrumbSEO
                items={[
                    {
                        name: "Blog",
                        href: Routes.blog,
                    },
                ]}
            />
            <UserFetcher>
                {({ user }) => <Navbar route={Routes.blog} user={user} />}
            </UserFetcher>
            <SidebarLayout pathname={Routes.blog} showFooter>
                <Breadcrumbs
                    pages={[
                        {
                            name: "Blog",
                            href: Routes.blog,
                        },
                    ]}
                />
                <PageWrapper>
                    <BlogListPage {...props} />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
